import { Document, Page, pdfjs } from 'react-pdf';
import http, { authHeaders } from '../../api/axios';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../api/apiUrl';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { Loader } from '../loader/Loader';

interface Props {
  id: string;
}
export enum SupportedFileType {
  PDF = 'application/pdf',
  IMG_JPEG = 'image/jpeg',
  IMG_PNG = 'image/png',
}

/**
 * Attachment preview component
 */
export default function FilePreview({ id }: Props) {
  const [url, setUrl] = useState<string>();
  const [pageNumber] = useState<number>(1);
  const [numPages, setNumPages] = useState<number | null>(null);
  const [fileType, setFileType] = useState<SupportedFileType>();

  /**
   * Sets number of pages of document
   */
  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setNumPages(numPages);
  };

  /**
   * Returns file´s blob url
   * @param apiGetFileUrl
   */
  const getFileBlobUrl = async (apiGetFileUrl: string) => {
    await http
      .apiGetFiles({
        url: apiGetFileUrl,
        config: {
          headers: {
            ...authHeaders(),
            'Content-Type': 'application/json',
            mode: 'cors',
          },
          method: 'GET',
          responseType: 'blob',
        },
      })
      .then((response) => response?.data)
      .then(async (data) => {
        if (!data.type) return;
        setFileType(data.type);
        const fileUrl: string = URL.createObjectURL(data);
        setUrl(fileUrl);
      });
  };

  useEffect(() => {
    getFileBlobUrl(`${apiUrl.FILE_DOWNLOAD}?id=${id}`);
    // to fix annotations
    // pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
  }, [id]);

  if (!fileType || !url) return <Loader />;
  return (
    <div className="relative text-center bg-gray-200 mt-0">
      {/* Image  */}
      {(fileType === SupportedFileType.IMG_JPEG || fileType === SupportedFileType.IMG_PNG) && (
        <div className="bg-white">
          <img src={url} alt="img" className="m-auto" />
        </div>
      )}
      {/* PDF file */}
      {fileType === SupportedFileType.PDF && (
        <>
          <div className="items-center justify-center h-[30px] w-[100%] bg-gray-800 text-white">
            <p className="h-[100%] justify-center p-2">
              Page {pageNumber} of {numPages}
            </p>
          </div>
          <div className="flex justify-center items-center p-2 ml-auto flex ml-auto">
            <Document
              file={url}
              onLoadSuccess={onDocumentLoadSuccess}
              options={{
                standardFontDataUrl: 'standard_fonts/',
              }}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <div key={index} className="mb-5">
                  <Page pageNumber={index + 1} />
                </div>
              ))}
            </Document>
          </div>
        </>
      )}
    </div>
  );
}
